export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_BFORCED = "SET_BFORCED";
